import { ApiProviderMetadataInvitationStatusChoices } from "@api/graphql/types-and-hooks";

export enum InviteStatus {
  Accepted = "Invite accepted",
  Pending = "Invite pending",
  Expired = "Invite expired",
  NotInvited = "Not invited yet",
}

export const getInviteStatus = (status: string): InviteStatus => {
  switch (status) {
    case ApiProviderMetadataInvitationStatusChoices.Accepted:
      return InviteStatus.Accepted;
    case ApiProviderMetadataInvitationStatusChoices.Pending:
      return InviteStatus.Pending;
    case ApiProviderMetadataInvitationStatusChoices.Expired:
      return InviteStatus.Expired;
    default:
      return InviteStatus.NotInvited;
  }
};

export const getInviteStatusTooltip = (status: InviteStatus): string => {
  switch (status) {
    case InviteStatus.Pending:
      return "An invite has been sent to this provider, but they haven’t accepted it yet. You’ll only have limited access to their details until they sign up for a full Frontera account.";
    case InviteStatus.NotInvited:
      return "This provider was added via a third-party integration and doesn’t have a full Frontera account yet. Until you invite them, you’ll only be able to view limited details.";
    default:
      return "";
  }
};
